import {
  FETCH_USER_ERROR,
  FETCH_USER_LOADING,
  SET_USER_DATA,
  UPDATE_USER_ERROR
} from 'appRedux/ActionTypes';
import { ICustomer } from 'interfaces';

export const fetchUserLoading = (loading = true) => ({
  type: FETCH_USER_LOADING,
  payload: loading
});
export const fetchUserError = (error: string) => ({
  type: FETCH_USER_ERROR,
  payload: error
});

export const updateUserError = (error: string) => ({
  type: UPDATE_USER_ERROR,
  payload: error
});

export const setUserData = (data: Partial<ICustomer>) => {
  return {
    type: SET_USER_DATA,
    payload: data
  };
};
